import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id: string;
};

export const useVehicleTypeDelete = () => {
  const [vehicleTypeDeleteLoading, setVehicleTypeDeleteLoading] =
    useState(false);

  const vehicleTypeDeleteReq = useCallback(async (params: TParams) => {
    setVehicleTypeDeleteLoading(true);
    const res = await request({
      path: "vehicle-Type/delete",
      method: "POST",
      body: JSON.stringify(params),
    });
    setVehicleTypeDeleteLoading(false);
    return res?.data;
  }, []);

  return { vehicleTypeDeleteLoading, vehicleTypeDeleteReq };
};
